module.exports = __webpack_public_path__ + "img/SuWebsite.4649ce5e.svg";